import { useMediaQuery } from 'react-responsive'

/**
 * Hook to check if the screen is at least the Tailwind `lg` breakpoint (1024px).
 * This is useful for responsive behavior that differs between mobile/tablet and desktop.
 *
 * @returns boolean - true if the screen width is >= 1024px
 *
 * @example
 * const isLargeScreen = useIsLargeScreen()
 * const stickyTop = isLargeScreen ? 112 : 86
 */
export const useIsLargeScreen = (): boolean => {
  return useMediaQuery({ minWidth: 1024 })
}
